import React from 'react';

import * as FiIcons from 'react-icons/fi';

import * as S from './Button.style';

type ExtroIcons = keyof typeof FiIcons;

export type ButtonVariant = 'primary' | 'secondary' | 'discrete';

export type ButtonTextPosition = 'left' | 'right';

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant: ButtonVariant;
  text: string | number;
  className?: string;
  icon?: ExtroIcons;
  textPosition?: ButtonTextPosition;
};

export const Button = ({ variant, children, text, className, icon, textPosition = 'left', ...props }: ButtonProps) => {
  return (
    <S.Button buttonStyle={variant} hasIcon={!!icon} className={className} {...props}>
      <>
        {!icon && text}
        {icon && (
          <S.Inner>
            {textPosition === 'left' && text}
            {icon && React.createElement(FiIcons[icon], { size: 22 })}
            {textPosition === 'right' && text}
          </S.Inner>
        )}
      </>
    </S.Button>
  );
};
